export default "__VITE_ASSET__uAc_g854__"